module.exports = __webpack_public_path__ + "img/big.661e214a.png";